import {
    FETCH_CHECKINPOINT,
    FETCH_CHECKINPOINTS,
} from '../actions/checkinpoint';


export const initialState = {
    isFetching: true,
    data: null
};

export const checkinpoints = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CHECKINPOINTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CHECKINPOINTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const checkinpoint = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CHECKINPOINT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CHECKINPOINT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/checkinpoint.js